<!--
 * @Description: 学期教学设置 详情
 * @Author: PF
 * @Date: 2023-12-21 15:40:04
 * @LastEditors: PF
 * @LastEditTime: 2023-12-21 16:15:44
-->

<template>
  <!-- <h1>学期教学计划列表</h1> -->
  <div class="tan-chuang">
    <div class="list-page">
      <el-dialog class="wp90 h800" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">详情</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-container>
          <el-main>
            <el-table :data="tableData" height="100%" border stripe v-loading="loading">
              <el-table-column label="顺序" prop="sx" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="周次" prop="zc" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>第{{scope.row.zc}}周</span>
                </template>
              </el-table-column>
              <el-table-column label="日期" prop="rq" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="星期" prop="xq" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>星期{{scope.row.xq}}</span>
                </template>
              </el-table-column>
              <el-table-column label="节次" prop="jc" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>第{{scope.row.jc}}节</span>
                </template>
              </el-table-column>
              <el-table-column label="场地" prop="jxcdmc" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column label="教学内容" header-align="center" prop="" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in neirongList" :key="index">
                 <span v-if="index === scope.$index && item.jxnrid!==null">{{item.jxnrbt}}</span>
                 <span v-if="index === scope.$index && item.jxnrid === null" >{{item.qtjxnr}}</span>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </el-dialog>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo'

const props = defineProps({ openDetail: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['update:openDetail', 'ReturnData'])
const neirongList = ref() // 列表拆分出来的内容列表
// 列表
const tableData = ref()
const gudingList = ref() // 列表拆分出来的固定列表
const loading = ref(false)
const bindTable = async () => {
  loading.value = true
  const o = {
    url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/jiaoshixueqijiaoxuejihuakebiao',
    data: parms.value
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      // step1: 调取列表后把列表拆分:内容放入一个单独的列表，固定项目放入一个单独的列表
      // 固定列表
      gudingList.value = res.data.map((item) => ({ bjid: item.bjid, id: item.id, jc: item.jc, jsid: item.id, jxcdid: item.jxcdid, jxcdmc: item.jxcdmc, jxdyid: item.jxdyid, kcid: item.id, qtjxnr: item.qtjxnr, rq: item.rq, sx: item.sx, xq: item.xq, xqid: item.xqid, zc: item.zc }))

      // 内容列表
      neirongList.value = res.data.map((item) => ({ jxnrbt: item.jxnrbt, jxnrid: item.jxnrid, qtjxnr: item.qtjxnr }))

      // 星期
      const weeks = ['', '一', '二', '三', '四', '五', '六', '日']
      res.data.forEach((element) => {
        element.xq = weeks[element.xq]
      })
      tableData.value = res.data
      loading.value = false
    } else {
      loading.value = false
      warningPrompt(res.message)
    }
  })
}
const parms = ref({})
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      parms.value = props.row
      bindTable()
    }
  },
  { deep: true, immediate: true }
)

</script>
